import React from 'react'
import { RouteObject, Navigate } from 'react-router-dom'

import { AccessGuard, CustomerLoginGuard } from '@guards'
import { MainLayout, HomeLayout } from '@components/systems'

// home
import CustomerLoginPage from '@pages/home/CustomerLogin.page'
import CustomerJoinPage from '@pages/home/CustomerJoin.page'
import CustomerForgotPwPage from '@pages/home/CustomerForgotPw.page'
import CustomerInfoPage from '@pages/home/CustomerInfo.page'
import CustomerOrderPage from '@pages/home/CustomerOrder.page'
import CustomerChangePasswordPage from '@pages/home/CustomerChangePassword.page'
import CustomerLogoutPage from '@pages/home/CustomerLogout.page'

import HomePage from '@pages/home/Home.page'
import SupportPage from '@pages/home/Support.page'
import ShopPage from '@pages/home/Shop.page'
import ShopKedem6Page from '@pages/home/ShopKedem6.page'
import ShopKedem4Page from '@pages/home/ShopKedem4.page'
import ShopAirMidiPog2Page from '@pages/home/ShopAirMidiPog2.page'
import ShopDualSwitchPage from '@pages/home/ShopDualSwitch.page'
import AboutPage from '@pages/home/About.page'
import ContactPage from '@pages/home/Contact.page'
import CartPage from '@pages/home/Cart.page'
import PaymentPage from '@pages/home/Payment.page'
import PaymentSuccessPage from '@pages/home/PaymentSuccess.page'

import ManualsPage from '@pages/home/Manuals.page'

import EventPage from '@pages/home/Event.page'

import PrivacyPolicyPage from '@pages/home/PrivacyPolicy.page'
import StorePolicyPage from '@pages/home/StorePolicy.page'

// main
import MainHomePage from '@pages/main/home/Home.page'
import ProductPage from '@pages/main/Product.page'
import ItemPage from '@pages/main/Item.page'
import SeasonPage from '@pages/main/Season.page'
import OrderPage from '@pages/main/Order.page'
import CustomerPage from '@pages/main/Customer.page'
import CouponPage from '@pages/main/Coupon.page'
import ResetMainCustomerPasswordPage from '@pages/main/ResetMainCustomerPassword.page'
import InquiryManagementPage from '@pages/main/InquiryManagement.page'

/* eslint-disable */
const HomeRoute = (mainUriList: { [id: string]: string }): RouteObject[] => {
	const res = [
		{
			path: '/',
			element: (
				<CustomerLoginGuard>
					<HomeLayout />
				</CustomerLoginGuard>
			),
			children: [
				{
					path: '*',
					element: <Navigate to="/" replace={true} />,
				},
				{
					path: '/',
					element: <HomePage />,
				},
				{
					path: '/customer/login',
					element: <CustomerLoginPage />,
				},
				{
					path: '/customer/join',
					element: <CustomerJoinPage />,
				},
				{
					path: '/customer/forgot-password',
					element: <CustomerForgotPwPage />,
				},
				{
					path: '/customer/info',
					element: <CustomerInfoPage />,
				},
				{
					path: '/customer/order',
					element: <CustomerOrderPage />,
				},
				{
					path: '/customer/change-password',
					element: <CustomerChangePasswordPage />,
				},
				{
					path: '/customer/logout',
					element: <CustomerLogoutPage />,
				},
				// {
				// 	path: '/pedals',
				// 	element: <PedalsPage />,
				// },
				{
					path: '/support',
					element: <SupportPage />,
				},
				{
					path: '/shop',
					element: <ShopPage />,
				},
				{
					path: '/shop/kdm6',
					element: <ShopKedem6Page />,
				},
				{
					path: '/shop/kdm4',
					element: <ShopKedem4Page />,
				},
				{
					path: '/shop/amp2',
					element: <ShopAirMidiPog2Page />,
				},
				{
					path: '/shop/ds',
					element: <ShopDualSwitchPage />,
				},
				{
					path: '/about',
					element: <AboutPage />,
				},
				{
					path: '/contact',
					element: <ContactPage />,
				},
				{
					path: '/cart',
					element: <CartPage />,
				},
				{
					path: '/payment',
					element: <PaymentPage />,
				},
				{
					path: '/payment-success',
					element: <PaymentSuccessPage />,
				},
				{
					path: '/privacy-policy',
					element: <PrivacyPolicyPage />,
				},
				{
					path: '/store-policy',
					element: <StorePolicyPage />,
				},
				{
					path: '/manuals',
					element: <ManualsPage />,
				},
				{
					path: '/event',
					element: <EventPage />,
				},
			],
		},
		{
			path: '/main',
			element: (
				<AccessGuard>
					<MainLayout />
				</AccessGuard>
			),
			children: [
				{
					path: '/main/empty',
					element: <></>,
				},
				{
					path: '/main/home',
					element: <MainHomePage />,
				},
				{
					path: '/main/product',
					element: <ProductPage />,
				},
				{
					path: '/main/item',
					element: <ItemPage />,
				},
				{
					path: '/main/season',
					element: <SeasonPage />,
				},
				{
					path: '/main/order',
					element: <OrderPage />,
				},
				{
					path: '/main/customer',
					element: <CustomerPage />,
				},

				{
					path: '/main/coupon',
					element: <CouponPage />,
				},
				{
					path: '/main/inquiry',
					element: <InquiryManagementPage />,
				},

				// @PLOP-CODE
			],
		},
		{
			path: '/main/reset-customer-password',
			element: (
				<AccessGuard>
					<ResetMainCustomerPasswordPage />
				</AccessGuard>
			),
		},
	]

	return res
}

export default HomeRoute
